import React from "react";



export const Settings = ()=>{
    return (<div><p>Settings...</p></div>)
}